import {useDebounce} from '../../../hooks/useDebounce';
import {useState} from 'react';

export const useDebouncedCompanyKeyWord = () => {
  const [inputValue, setInputValue] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');

  const keyWord = useDebounce(searchValue);

  const handleInputChange = (_: unknown, searchValue: string, reason: string) => {
    setInputValue(searchValue);
    if (reason !== 'input') return;
    setSearchValue(searchValue);
  };

  return {keyWord, inputValue, handleInputChange};
};
